// src/components/MessageList/MessageList.tsx
import React, { useEffect, useRef } from "react";
import type { ChatMessage } from "../../types";
import { stripMarkdown } from "../../utils/markdown";
import "./MessageList.scss";

interface MessageListProps {
    messages: ChatMessage[];
}

export const MessageList: React.FC<MessageListProps> = ({ messages }) => {
    const messagesEndRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const getMessageKey = (message: ChatMessage, index: number): string => {
        if (message.id) {
            return message.id;
        }
        return `msg-${index}-${message.timestamp}`;
    };

    if (messages.length === 0) {
        return null;
    }

    return (
        <div className="message-list">
            {messages.map((message, index) => {
                const isUser = message.type === "user";
                const key = getMessageKey(message, index);
                const isLoading = message.isThinking || message.isRecognizing;

                return (
                    <div
                        key={key}
                        className={`message-item ${isUser ? "msg-user" : "msg-assistant"} ${isLoading ? "msg-thinking" : ""}`}
                    >
                        <div className="msg-avatar">
                            {isUser ? (
                                "👤"
                            ) : (
                                <img
                                    src="/avatar.png"
                                    alt="金小卫"
                                />
                            )}
                        </div>
                        <div className="msg-bubble">
                            {isLoading ? (
                                <div className="msg-thinking-content">
                                    <span className="thinking-dots">
                                        <span className="dot" />
                                        <span className="dot" />
                                        <span className="dot" />
                                    </span>
                                </div>
                            ) : (
                                <pre className="msg-text">
                                    {isUser
                                        ? message.content
                                        : stripMarkdown(message.content)}
                                </pre>
                            )}
                        </div>
                    </div>
                );
            })}
            <div ref={messagesEndRef} />
        </div>
    );
};

export default MessageList;
